const adminProfile = {
  actions: {
    close: '关闭个人设置',
  },
  errors: {
    accountUnavailable: '当前管理员账号不可用，请联系超级管理员。',
    currentPasswordIncorrect: '当前密码不正确。',
    forbidden: '你没有权限执行这个操作。',
    generic: '操作失败，请稍后重试。',
    missingPasswordFields: '请填写当前密码和新密码。',
    network: '网络异常，请检查连接后重试。',
    serviceUnavailable: '服务暂时不可用，请稍后重试。',
    sessionExpired: '登录状态已过期，请重新登录。',
  },
  fallbackName: '管理员',
  fields: {
    confirmPassword: '确认新密码',
    currentPassword: '当前密码',
    displayName: '名称',
    newPassword: '新密码',
  },
  loadErrorDescription: '无法读取当前管理员账号信息。',
  nameEditor: {
    cancel: '取消',
    close: '关闭名称编辑',
    edit: '编辑名称',
    placeholder: '输入管理员显示名称',
    submit: '保存名称',
    title: '编辑名称',
  },
  password: {
    cancel: '取消',
    close: '关闭密码编辑',
    hidePassword: '隐藏密码',
    modalTitle: '修改密码',
    reloginNotice: '密码保存成功后，当前后台会话会被撤销并返回管理员登录页。',
    reset: '重置密码',
    showPassword: '显示密码',
    submit: '保存密码',
    title: '密码',
  },
  success: {
    passwordChanged: '密码已更新，请重新登录',
    profileSaved: '个人信息已保存',
  },
  tabs: {
    basic: '基础信息',
    label: '个人设置分区',
  },
  title: '个人设置',
  validation: {
    confirmPasswordMismatch: '两次输入的新密码不一致。',
    currentPasswordRequired: '请输入当前密码。',
    nameRequired: '名称不能为空。',
    newPasswordLength: '新密码至少需要 8 个字符。',
  },
}

export default adminProfile
